<template>
  <div>
    <topNav></topNav>
    <div class="j_content">
      <div class="coupon_goods_list_wrapper">
        <ul class="coupon_goods_list_ul clearfix" >
          <router-link :to="{ name: 'item', params: { id: dataList.id }}" v-for="(dataList,index) in dataLists" :key="dataList.id" :class="index==0?'coupon_goods_list_li1':'coupon_goods_list_li'">
            <div v-if="index==0" class="coupon_goods_list_li1_inner">
              <div class="li_left">
                <strong class="czg">超值购</strong>
                <img :src="dataList.goodsPic" class="goods_pic"/>
                <p v-if="index==1" class="left_coupon">还剩{{dataList.couponReserve
    }} 张券</p>
              </div>
              <div class="li_right">
                <p class="goods_title"><img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
                <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
                <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
                <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
                <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
                <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.goodsName}}</p>
                <div class="des_wrapper">
                  <div class="des_content">
                    <p class="mark">超值限量  神券相助</p>
                    <div class="goods_coupon">
                      <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
          }}</span>
                    </div>
                    <div class="goods_money">
                      <span class="goods_money_l"><span class="s1">￥{{dataList.finalPrice}}</span><span class="s2">￥{{dataList.price}}</span></span>
                    </div>
                  </div>
                  <div class="time_wrapper">
                      <p class="time">仅剩 {{dataList.endTime}}</p>
                      <div class="btn">
                        马上抢>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="index>0">
              <div class="li_top">
                <img :src="dataList.goodsPic" class="goods_pic"/>
                <p v-if="index==1" class="left_coupon">还剩{{dataList.couponReserve
    }} 张券</p>
              </div>
              <div class="li_btm">
                <p class="goods_title">{{dataList.goodsName}}</p>
                <p class="goods_shop">
                  <img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
                  <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
                  <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
                  <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
                  <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
                  <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.shopName}}</p>
                <div class="goods_coupon">
                  <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
      }}</span>
                </div>
                <div class="goods_money">
                  <span class="goods_money_l"><span class="s1">券后</span><span class="s2">￥{{dataList.finalPrice}}</span></span>
                  <span class="goods_money_r">原价￥{{dataList.price}}</span>
                </div>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
  import TopNav from '@/components/common/topNav'
  import { Indicator } from 'mint-ui' //提示搜索优惠券
  import {getTimeDiff} from "../../common/js/common.js"//获取时间戳函数
  export default {
    name:'jhs',
    data(){
      return {
        url:'',
        dataLists:[],
        page:1,
        loading:false,
        REQUIRE:false,
        pageSize:11,
        order:"addTime",
        catalog:"聚划算",
        keyword:'isJuhuaSuan'
      }
    },
    methods:{
     /*axios调用数据*/
      login () {
        this.url = "api/getGoods.php?page="+this.page+"&pageSize="+this.pageSize+"&order=addTime&keyword="+this.keyword+"&searchType=goodsMenu&catalog="+this.catalog//用商品列表页url代替
        console.log(this.url )
        this.$ajax.autoService
            .login(this.url)
            .then((res) => {
              this.dataLists = this.dataLists.concat(res.data.map(function(item){
                item.finalPrice = (item.price - item.money).toFixed(0);
                item.coupon_price = parseInt(item.coupon_price)
                item.goodsName = item.goodsName.slice(0,36)
                var temp = item.goodsPic
                temp = temp.replace('https:', '')
                temp = temp.replace('http:', '')
                item.goodsPic = "https:" + temp
                item.endTime = getTimeDiff(item.couponEndTime)
                return item
              }))
              //this.loading = false
              this.$nextTick(() => {
                this.REQUIRE = true;
                this.loading = false;
                Indicator.close()
              });
              console.log(this.dataLists)
            }, (res) => {
                console.log("error")
                this.REQUIRE = true;
            })
       },
       /*axios向下加载*/
       scrollBottom() {
        // 滚动到页面底部时，请求前一天的文章内容
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

        if (((window.screen.height + scrollTop) > (document.body.clientHeight))-10 && this.REQUIRE) {
          // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
          this.REQUIRE = false;
          this.loading = true;
          this.tips = '努力加载中...';
          this.page+=1
          this.pageSize=10
          this.login(this.url)
          Indicator.open('正在加载优惠券');

    }
  }
},
  created (){
   this.login(this.url)
  },
  mounted(){
     window.addEventListener('scroll', this.scrollBottom)
  },
  beforeDestroy(){
    Indicator.close()
  },
  components:{
    'topNav':TopNav,
  },
  }
</script>
<style lang="stylus">
.j_content
  background:url("../../images/jhs_bg.jpg")no-repeat left top
  background-size:750px 409px
  padding-top:150px
  width:750px
  display:block
  .coupon_goods_list_wrapper
    width:750px
    overflow:hidden
    .coupon_goods_list_ul
      width:760px
      .coupon_goods_list_li
        width:370px
        float:left;
        margin:10px 10px 0 0
        padding:0 0 20px 0
        background:#fff
        border:1px solid #e6e6e6
        box-sizing:border-box
        .li_top
          width:100%
          height:368px
          position:relative
          .goods_pic
            width:100%
            height:368px
          .left_coupon
            width:100%
            position:absolute
            left:0px
            bottom:0px
            height:40px
            background:rgba(255,101,0,0.6)
            color:#fff
            font-size:24px
            text-align:center
            line-height:40px
        .li_btm
          padding:10px 15px
          .goods_title
            font-size:28px
            color:#333
            line-height:32px
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            height:60px
          .goods_shop
            font-size:20px
            color:#999
            margin-top:10px
            .n_goods_shop_img
              width:20px
              height:20px
              display:inline-block
              vertical-align:middle
              margin-left:10px
          .goods_coupon
            height:36px
            color:#fff
            line-height:36px
            font-size:0px
            margin-top:15px
            .goods_coupon_l
              padding:0 8px
              background:#ff6500
              display:inline-block
              vertical-align:top
              font-size:22px
              height:36px
            .goods_coupon_c
              width:13px
              height:36px
              vertical-align:top
            .goods_coupon_r
              background:#ff5400
              display:inline-block
              vertical-align:top
              padding:0 10px
              height:36px
              font-size:22px
          .goods_money
            display:flex
            margin-top:15px
            justify-content:space-between
            line-height:30px
            .goods_money_l
              color:#f40
              .s1
                font-size:22px
                margin-right:5px
              .s2
                font-size:30px
            .goods_money_r
              font-size:22px
              color:#999
              text-decoration: line-through
      .coupon_goods_list_li1
        width:715px
        padding:20px
        background:#fff
        border-radius:20px
        display:block
        box-sizing:border-box
        margin:0 auto 10px 18px
        .coupon_goods_list_li1_inner
          display:flex
          .li_left
            flex:0 0 240px
            .czg
              font-size:30px
              color:#333
              font-weight:bold
            .goods_pic
              width:220px
              height:170px
              display:block
              margin-top:10px
          .li_right
            flex:1
            .goods_title
              font-sizr:30px
              color:#333
              .n_goods_shop_img
                width:20px
                height:20px
                vertical-align:middle
            .des_wrapper
              color:#fff
              line-height:36px
              font-size:0px
              margin-top:25px
              display:flex
              .des_content
                flex:1
                .mark
                  font-size:24px
                  color:#999
                  margin-bottom:15px
                .goods_coupon_l
                  padding:0 8px
                  background:#ff6500
                  display:inline-block
                  vertical-align:top
                  font-size:22px
                  height:36px
                .goods_coupon_c
                  width:13px
                  height:36px
                  vertical-align:top
                .goods_coupon_r
                  background:#ff5400
                  display:inline-block
                  vertical-align:top
                  padding:0 10px
                  height:36px
                  font-size:22px
                .goods_money
                  margin-top:20px
                  .s1
                    font-size:36px
                    color:#f40
                  .s2
                    font-size:24px
                    color:#999
                    margin-left:10px
                    text-decoration:line-through
              .time_wrapper
                flex:0 0 170px
                padding-top:20px
                .time
                  font-size:20px
                  color:#ff4600
                  text-align:center
                .btn
                  width:100%
                  height:60px
                  background:#ff4400
                  font-size:28px
                  color:#fff
                  text-align:center
                  line-height:60px
                  margin-top:10px
                  border-radius:10px

</style>



// WEBPACK FOOTER //
// src/components/goodsNav/jhs.vue